import React from "react";
import Indusone from "../../images/STEEL PIPES AND OTHERS/STEEL PIPES/4. SSAW PIPES/7.png";
// import Indusones from "../../images/STEEL PIPES AND OTHERS/STEEL PIPES/4. SSAW PIPES/4.jpg";

function OurExpertise() {
  return (
    <div className="w-full">
      {/* Top Section - Image & Text */}
      <div className="mx-auto md:mt-3">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-3 items-stretch">
          {/* Left Side - Text Content */}
          <div className="lg:col-span-5 bg-white text-[#0c2340] p-6 rounded-lg duration-300 ease-in-out flex flex-col justify-center md:h-[400px]">
            <h2 className="text-2xl md:text-4xl font-bold mb-1 md:mb-4 text-center">
            AKT STEEL PIPES
            </h2>
            <p className="text-sm md:text-lg mb-6 text-justify md:mt-2">
            AKT takes pride in supplying high-quality steel pipe solutions, offering both new surplus and used steel pipes known for their exceptional durability and clean appearance. We focus on delivering reliable, affordable, and sustainable products that meet diverse project needs, ensuring your structures last while staying cost-effective. With a wide selection and a commitment to quality, AKT is your trusted source for steel pipes that combine strength, value, and visual appeal, making us the preferred choice for all your steel pipe requirements.
            </p>
          </div>
          {/* <div className="lg:col-span-5 rounded-lg duration-300 ease-in-out flex flex-col justify-center md:h-[400px]">
          <div className="w-full h-[400px] overflow-hidden rounded-lg">
              <img
                src={Indusones}
                alt="Offshore Industry"
                className="w-full h-full object-cover transition-transform duration-300 ease-in-out hover:scale-110"
              />
            </div>
          </div> */}

          {/* Right Side - Image */}
          <div className="lg:col-span-7 flex">
            <div className="w-full h-[400px] overflow-hidden rounded-lg">
              <img
                src={Indusone}
                alt="Offshore Industry"
                className="w-full h-full object-cover transition-transform duration-300 ease-in-out hover:scale-110"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default OurExpertise;

